import { ComponentService } from "../Services/Axios/Api";

class MediaGalleryFolders {
    data = {};

    constructor() {
        this.data = {
            id: "",
            ComponentName: "MediaGalleryFolders",
            // folders: [{ id, folderName, folderMainImage, folderImages: [] }]
            folders: [],
        };
    }

    // Id
    getId() { return this.data.id; }
    setId(id) { this.data.id = id; }

    // Name
    getComponentName() { return this.data.ComponentName; }
    setComponentName(ComponentName) { this.data.ComponentName = ComponentName; }

    // Folders
    getFolders() { return [...this.data.folders]; }
    setFolders(folders) { this.data.folders = [...folders]; }

    _generateFolderId() {
        const existingIds = this.data.folders
            .map((f) => Number(f.id))
            .filter((n) => !Number.isNaN(n));
        const nextId = existingIds.length > 0 ? Math.max(...existingIds) + 1 : 1;
        return String(nextId);
    }

    addFolder({ folderName, folderMainImage = "", folderImages = [] }) {
        const newFolder = {
            id: this._generateFolderId(),
            folderName: folderName || `Folder ${this.data.folders.length + 1}`,
            folderMainImage,
            folderImages: Array.isArray(folderImages) ? [...folderImages] : [],
        };
        this.data.folders = [...this.data.folders, newFolder];
        return newFolder;
    }

    updateFolder(folderId, updates) {
        this.data.folders = this.data.folders.map((folder) =>
            String(folder.id) === String(folderId)
                ? { ...folder, ...updates, images: updates.images ?? folder.images }
                : folder
        );
    }

    removeFolder(folderId) {
        this.data.folders = this.data.folders.filter(
            (folder) => String(folder.id) !== String(folderId)
        );
    }

    getFolderById(folderId) {
        return this.data.folders.find(
            (folder) => String(folder.id) === String(folderId)
        );
    }

    setFolderMainImage(folderId, imageUrl) {
        this.updateFolder(folderId, { folderMainImage: imageUrl });
    }

    addImagesToFolder(folderId, imageUrls) {
        if (!Array.isArray(imageUrls) || imageUrls.length === 0) return;

        this.data.folders = this.data.folders.map((folder) => {
            if (String(folder.id) !== String(folderId)) return folder;
            const existingImages = Array.isArray(folder.folderImages) ? folder.folderImages : [];
            const uniqueNewImages = imageUrls.filter(
                (url) => !existingImages.includes(url)
            );
            return {
                ...folder,
                folderImages: [...existingImages, ...uniqueNewImages],
            };
        });
    }

    removeImageFromFolder(folderId, imageUrl) {
        this.data.folders = this.data.folders.map((folder) => {
            if (String(folder.id) !== String(folderId)) return folder;
            const existingImages = Array.isArray(folder.folderImages) ? folder.folderImages : [];
            return {
                ...folder,
                folderImages: existingImages.filter((img) => img !== imageUrl),
            };
        });
    }

    removeImageFromFolderByIndex(folderId, index) {
        this.data.folders = this.data.folders.map((folder) => {
            if (String(folder.id) !== String(folderId)) return folder;
            const existingImages = Array.isArray(folder.folderImages) ? folder.folderImages : [];
            if (index < 0 || index >= existingImages.length) return folder;
            return {
                ...folder,
                folderImages: existingImages.filter((_, i) => i !== index),
            };
        });
    }

    // Data
    getData() { return this.data; }
    setData(data) { this.data = data; }

    // Methods
    async load(id) {
        try {
            let response = {};
            let data = {};

            if (id) {
                response = await ComponentService.getComponentById(id);
                data = response.data ? JSON.parse(response.data) : {};
                this.setId(response?.id);
            } else {
                response = await ComponentService.getComponent(this.data.ComponentName);
                this.setId(response[0]?.id);
                data = JSON.parse(response[0]?.data);
            }

            if (Object.keys(data).length > 0) {
                this.setData(data);
                this.setFolders(data.folders || []);
            }
            return data;
        } catch (error) {
            throw new Error(error.response?.data || "Failed to load MediaGalleryFolders");
        }
    }

    async save() {
        try {
            const response = await ComponentService.SaveData(
                this.getId(),
                this.getData()
            );
            return response;
        } catch (error) {
            throw new Error(error.response?.data || "Failed to save MediaGalleryFolders");
        }
    }
}

export const createMediaGalleryFoldersInstance = () => new MediaGalleryFolders();


